<template>
  <!-- 受付内容編集 -->
  <div id="HSTDetailEdit">
    <div id="container">
      <div class="labelTitle lable">睡眠検査機器配送ｻｰﾋﾞｽ 受付内容編集</div>
      <div class="button-area">
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div id="item-contens" v-if="isLoad">
        <div class="card-content margin-top">
          <span style="font-size: 20px">基本情報</span>
          <table>
            <tr><th>受付番号</th><td>{{targetNumber.join(',')}}</td></tr>
            <tr><th>医療機関名</th><td>{{commonItems.hospitalName}}</td></tr>
            <tr><th>医師名</th><td><input type="text" v-model="commonItems.doctorName" maxlength="105" :disabled="commonItems.isComp"/></td></tr>
            <tr><th>事務担当者名</th><td><input type="text"  v-model="commonItems.clerkName" maxlength="100" :disabled="commonItems.isComp"/></td></tr>
            <tr><th>機種<span class="require"/></th>
              <td v-if="!commonItems.isDeviceReservation&&!commonItems.isComp && modelList.length > 1"><select id="model" name="機種" validate="required" @change="changeCommonItems(modelId,'model')" v-model="modelId"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td>
              <td v-else>{{modelId  | getNameFilter(allModelList) }}</td>
            </tr>
            <tr v-if="modelId == '7'">
              <th></th><td><b-checkbox class="cstmCheckBox" v-model="commonItems.snoreSensor" :disabled="disabledSnoreSensor">いびきセンサーあり</b-checkbox></td>
            </tr>
            <tr v-if="!commonItems.isDeviceReservation && !commonItems.isComp && modelList.length <= 1"><th></th><td>契約済の機種がないため、機種の変更ができません。</td></tr>
            <tr><th>機器配送先<span class="require"/></th><td>
              <div class="block">
                <b-radio class="td_radio" id="delivaryHome" v-model="commonItems.delivaryTarget" :disabled="data.length >= 2 || commonItems.isShipped" native-value="home">患者宅に配送する</b-radio>
                <b-radio class="td_radio" id="delivaryHospital" v-model="commonItems.delivaryTarget" :disabled="data.length >= 2 || commonItems.isShipped" native-value="hospital">医療機関に配送する</b-radio>
              </div></td>
            </tr>
            <template v-if="commonItems.delivaryTarget== 'hospital'">
              <tr><th>【機器配送先】</th>
              <tr>
                <th vertical-align="top">郵便番号<span class="require"/></th>
                <td>
                  <input
                    id="hospitalPostcode"
                    :disabled="commonItems.isComp"
                    style="width: 270px;"
                    v-model="commonItems.hospitalPostcode"
                    class="edit"
                    :class="{'border-red': invalidShippingPostCode}"
                    name="機器配送先の郵便番号"
                    validate="required|numeric|zip"
                    maxlength="7"
                    :placeholder="postcodePlaceholder"
                    @blur="onZipBlur(commonItems.hospitalPostcode, 'digitErrorHospitalPostcode')"
                  />
                  <b-button
                    style="margin-left: 10px; width: 150px; height: 27px;"
                    v-on:click="addressSearch('device',commonItems.hospitalPostcode)"
                  >
                    自動入力
                  </b-button>
                  <div v-if="invalidShippingPostCode" class="text-red">{{ invalidNumberMessage }}</div>
                  <div v-if="digitErrorHospitalPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                </td>
              </tr>
              <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.hospitalAddress" class="edit" name="機器配送先の住所（都道府県、市町村区）" validate="required" maxlength="280"/></td></tr>
              <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.hospitalHouseNumber" class="edit" name="機器配送先の住所（それ以降の住所）" validate="required" maxlength="256" ref="hospitalHouseNumber"/></td></tr>
              <tr><th>住所（建物名、部屋番号）</th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.hospitalBuilding" maxlength="256"/></td></tr>
              <tr><th>宛名<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.hospitalDestination" maxlength="100" class="edit" name="機器配送先の宛名" validate="required"/></td></tr>
              <tr>
                <th>連絡先(電話番号)<span class="require"/></th>
                <td>
                  <input
                    :disabled="commonItems.isComp"
                    type="text"
                    v-model="commonItems.hospitalPhoneNumber"
                    maxlength="11"
                    class="edit"
                    :class="{'border-red': invalidShippingPhoneNumber}"
                    name="機器配送先の連絡先(電話番号)"
                    validate="required|numeric"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-if="invalidShippingPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <tr><th>配達希望時間帯</th>
                <td v-if="!commonItems.isComp"><select v-model="commonItems.hospitalDesiredPickupTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td>
                <td v-else>{{commonItems.hospitalDesiredPickupTimeZone  | getNameFilter(desiredDeliveryTimeZoneList) }}</td>
              </tr>
            </template>
            <template v-if="commonItems.createInternal">
              <tr><th>【結果送付先】</th></tr>
              <tr>
                <th vertical-align="middle">郵便番号<span class="require"/></th>
                <td>
                  <input
                    id="resultDeliveryPostcode"
                    :disabled="commonItems.isComp"
                    style="width: 270px;"
                    v-model="commonItems.resultDeliveryPostcode"
                    maxlength="7"
                    class="edit"
                    :class="{'border-red': invalidDeliveryPostCode}"
                    name="結果送付先の郵便番号"
                    validate="required|numeric|zip"
                    :placeholder="postcodePlaceholder"
                    @blur="onZipBlur(commonItems.resultDeliveryPostcode, 'digitErrorResultPostcode')"
                  />
                  <b-button
                    style="margin-left: 10px; width: 150px; height: 27px;"
                    v-on:click="addressSearch('result',commonItems.resultDeliveryPostcode)">
                    自動入力
                  </b-button>
                  <div v-if="invalidDeliveryPostCode" class="text-red">{{ invalidNumberMessage }}</div>
                  <div v-if="digitErrorResultPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                </td>
              </tr>
              <tr><th>住所<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.resultDeliveryAddress" maxlength="280" class="edit" name="結果送付先の住所" validate="required" ref="resultAddress"/></td></tr>
              <tr><th>住所（建物名、部屋番号）</th><td><input :disabled="commonItems.isComp" type="text" v-model="commonItems.resultDeliveryBuilding" maxlength="256"/></td></tr>
              <tr><th>医療機関名(会社名)</th><td><input :disabled="commonItems.isComp" type="text" placeholder="宛名を個人宛にする場合、医療機関名(会社名）はこちらに入力してください。" v-model="commonItems.resultDeliveryHospital" maxlength="256"/></td></tr>
              <tr><th>診療科(部署名)</th><td><input :disabled="commonItems.isComp" type="text" placeholder="宛名を個人宛にする場合、診療科(部署名）はこちらに入力してください。" v-model="commonItems.resultDeliveryDepartment" maxlength="100"/></td></tr>
              <tr><th>宛名<span class="require"/></th><td><input :disabled="commonItems.isComp" type="text" placeholder="宛名に医療機関(会社名)を入れる場合、「医療機関名(会社名)」「診療科(部署名)」欄は空欄にしてください。" v-model="commonItems.resultDeliveryDestination" maxlength="100" class="edit" name="結果送付先の宛名" validate="required"/></td></tr>
              <tr>
                <th>連絡先(電話番号)<span class="require"/></th>
                <td>
                  <input
                    :disabled="commonItems.isComp"
                    type="text"
                    v-model="commonItems.resultDeliveryPhoneNumber"
                    maxlength="11"
                    class="edit"
                    :class="{'border-red': invalidDeliveryPhoneNumber}"
                    name="結果送付先の連絡先(電話番号)"
                    validate="required|numeric"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-if="invalidDeliveryPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
            </template>
            <tr><th class="deliverySlip_label">納品書</th><td>
              <div>
                <b-radio class="td_radio deliverySlip_radio" v-model="commonItems.deliverySlip" :native-value="true" :disabled="commonItems.isComp">必要</b-radio>
                <b-radio class="td_radio deliverySlip_radio" v-model="commonItems.deliverySlip" :native-value="false" :disabled="commonItems.isComp">不要</b-radio>
              </div>
            </td></tr>
            <tr><th>デモ</th><td><b-checkbox :disabled="commonItems.isComp" v-model="commonItems.demo" class="cstmCheckBox" @input="setModelList">デモ(トライアル)</b-checkbox></td></tr>
          </table>
        </div>
        <template v-for="(patent, index) in data">
          <div class="card-content margin-top" :key="index">
            <span style="font-size: 20px">申込み内容{{index+1}}（受付番号：{{patent.receptionNo}}）</span>
            <div class="card-content margin-top">
              <span style="font-size: 20px">患者情報</span>
              <table>
                <tr>
                  <th>ステータス</th>
                  <td><span :class="getTabClass4InternalStatus(patent.status)" style="height:30px;margin-left:5px;width:20%;">{{getStatus(patent.status)}}</span>
                  </td>
                </tr>
                <tr><th>診察券ID（患者ID）<span class="require" /></th><td><input :disabled="patent.isComp" v-model="patent.patientId" @input="patent.patientId = $event.target.value.replace(/^\s+/, '')" type="text" maxlength="50" :class="'edit'+index" :name="index+1+'番目、診察券ID（患者ID）'"  validate="required"/></td></tr>
                    <tr><th>患者名<span class="require" /></th><td><input :disabled="patent.isComp" style="margin-right:5px; width:450px;" v-model="patent.patientFamilyName" type="text" placeholder="姓" maxlength="49" :class="'edit'+index" :name="index+1+'番目、患者名(姓)'" validate="required" /><input :disabled="patent.isComp" style="width:450px;" v-model="patent.patientFirstName" type="text" placeholder="名" maxlength="49" :class="'edit'+index" :name="index+1+'番目、患者名(名)'" validate="required"/></td></tr>
                    <tr><th>患者名（カナ）<span class="require" /></th><td><input :disabled="patent.isComp" style="margin-right:5px; width:450px;" v-model="patent.patientFamilyNameKana" type="text" placeholder="セイ" maxlength="49" :class="'edit'+index" :name="index+1+'番目、患者名カナ(セイ)'" validate="required|kana"/><input :disabled="patent.isComp" style="width:450px;" v-model="patent.patientFirstNameKana" type="text" placeholder="メイ" maxlength="49" :class="'edit'+index" :name="index+1+'番目、患者名カナ(メイ)'" validate="required|kana"/></td></tr>
                <tr><th>性別<span class="require" /></th><td>
                  <div class="block">
                    <b-radio :disabled="patent.isComp" class="td_radio" size="is-small" v-model="patent.gender" native-value="-">-</b-radio>
                    <b-radio :disabled="patent.isComp" class="td_radio" size="is-small" v-model="patent.gender" native-value="男">男</b-radio>
                    <b-radio :disabled="patent.isComp" class="td_radio" size="is-small" v-model="patent.gender" native-value="女">女</b-radio>
                  </div></td>
                </tr>
                <tr><th>生年月日<span class="require" /></th><td><input :disabled="patent.isComp" v-model="patent.birthday" type="date" :input="inputBirthday(patent.birthday,index)" :class="'edit'+index" :name="index+1+'番目、患者の生年月日'" validate="required|date|birthDay" style="width:150px;" :max="yyyy_hyp_MM_hyp_dd(new Date())" /></td></tr>
                <tr><th>年齢</th><td><input type="text" v-model="patent.age" disabled/></td></tr>
                <tr v-if="isSW()"><th>カニューラサイズ<span class="require" /></th>
                  <td v-if="!patent.isComp"><select v-model="patent.cannulaSize" :class="'edit'+index" :name="index+1+'番目、患者のカニューラサイズ'" validate="required"><option v-for="cannulaSize in cannulaSizeList" :value="cannulaSize.value" :key="cannulaSize.value">{{ cannulaSize.label1 }}</option></select></td>
                  <td v-else>{{patent.cannulaSize  | getNameFilter(cannulaSizeList) }}</td>
                </tr>
                <tr v-if="isSW()"><th>ベルトサイズ<span class="require" /></th>
                  <td v-if="!patent.isComp"><select v-model="patent.beltSize" :class="'edit'+index" :name="index+1+'番目、患者のベルトサイズ'" validate="required"><option v-for="beltSize in beltSizeList" :value="beltSize.value" :key="beltSize.value">{{ beltSize.label1 }}</option></select></td>
                  <td v-else>{{patent.beltSize  | getNameFilter(beltSizeList) }}</td>
                </tr>
                <tr v-if="isSW()"><th>添付波形<span class="require" /></th>
                  <td v-if="!patent.isComp"><select v-model="patent.attachedWaveform" :class="'edit'+index" :name="index+1+'番目、患者の添付波形'" validate="required"><option v-for="attachedWaveform in attachedWaveformList" :value="attachedWaveform.value" :key="attachedWaveform.value">{{ attachedWaveform.label1 }}</option></select></td>
                  <td v-else>{{patent.attachedWaveform  | getNameFilter(attachedWaveformList) }}</td>
                </tr>
                <tr><th>次回受診日</th><td><input :disabled="patent.isComp" v-model="patent.nextDate" type="date" :class="'edit'+index" :name="index+1+'番目、患者の次回受診日'" validate="date" style="width:150px;"/></td></tr>
                <template v-if="commonItems.delivaryTarget === 'home'">
                  <tr>
                    <th>郵便番号<span class="require"/></th>
                    <td>
                      <input
                        :id="`postcode_${index}`"
                        :disabled="patent.isComp"
                        type="text"
                        style="width: 270px;"
                        v-model="patent.postcode"
                        maxlength="7"
                        :class="['edit'+ index, {'border-red': patent.invalidPatientPostCode}]"
                        :name="index+1+'番目、患者の郵便番号'"
                        validate="required|numeric|zip"
                        :placeholder="postcodePlaceholder"
                        @blur="onZipBlur(patent.postcode, patent)"
                      />
                      <b-button
                        style="margin-left: 10px; width: 150px; height: 27px;"
                        v-on:click="patientAddressSearch(index,patent.postcode)"
                      >
                        自動入力
                      </b-button>
                      <div v-show="patent.invalidPatientPostCode" class="text-red">{{ invalidNumberMessage }}</div>
                      <div v-show="patent.digitErrorPatientPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                    </td>
                  </tr>
                  <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td><input :disabled="patent.isComp" type="text" v-model="patent.address" maxlength="256" :class="'edit'+index" :name="index+1+'番目、患者の住所（都道府県、市町村区）'" validate="required"/></td></tr>
                  <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input :disabled="patent.isComp" type="text" :id="`houseNumber_${index}`" v-model="patent.houseNumber" maxlength="256" :class="'edit'+index" :name="index+1+'番目、患者の住所（それ以降の住所）'" validate="required"/></td></tr>
                  <tr><th>住所（建物名、部屋番号）</th><td><input :disabled="patent.isComp" v-model="patent.building" type="text" maxlength="256"/></td></tr>
                  <tr><th>宛名<span class="require"/></th><td><input :disabled="patent.isComp" v-model="patent.destination" type="text" maxlength="100" :class="'edit'+index" :name="index+1+'番目、患者の宛名'" validate="required"/></td></tr>
                  <tr>
                    <th>連絡先（自宅または携帯）<span class="require" /></th>
                    <td>
                      <input
                        :disabled="patent.isComp"
                        type="text"
                        v-model="patent.phoneNumber"
                        maxlength="11"
                        :placeholder="phonePlaceholder"
                        :class="['edit'+ index, {'border-red': patent.invalidPatientPhoneNumber}]"
                        :name="index+1+'番目、患者の連絡先（自宅または携帯）'"
                        validate="required|numeric"
                      />
                      <div v-show="patent.invalidPatientPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                    </td>
                  </tr>
                  <tr><th>配達希望時間帯</th>
                    <td v-if="!patent.isComp"><select v-model="patent.desiredPickupTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td>
                    <td v-else>{{patent.desiredPickupTimeZone  | getNameFilter(desiredDeliveryTimeZoneList) }}</td>
                  </tr>
                </template>
                <tr>
                  <th style="vertical-align:top;">患者備考</th><td><textarea :disabled="patent.isComp" v-model="patent.patientNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
                </tr>
                <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
                  <reasonInputModal  v-on:setReason="reasonInput" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
                </b-modal>
              </table>
            </div>
            <div class="card-content margin-top">
              <span style="font-size: 20px">配送先情報</span>
              <table>
                <tr><th>出荷日<span class="require"/></th>
                  <td v-if="!patent.isShipped&&!patent.isComp"><input type="date" v-model="patent.desiredShippingDate" disabled style="width:150px;" validate="required"/><a @click="desiredShippingDateSelect(index)"><b-icon icon="calendar-cursor"></b-icon></a></td>
                  <td v-else>{{patent.desiredShippingDate | formatDate}}</td>
                </tr>
                <tr>
                  <th style="vertical-align:top;">配送先備考</th>
                  <td><textarea :disabled="patent.isComp" v-model="patent.DeliveryInformationNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
                </tr>
              </table>
            </div>
            <div class="card-content margin-top" v-if="patent.reception">
              <span style="font-size: 20px">受付情報</span>
              <table>
                <tr><th>シリアル</th><td>{{patent.serial}}
                  <b-button v-if="patent.serial && !patent.isShipped" style="margin-left:10px; width:150px; height:27px;" v-on:click="changeSerial(index, patent.serial, patent.receptionNo)">予約機器変更</b-button></td>
                </tr>
                <tr>
                  <th style="vertical-align:top;">受付備考</th><td><textarea :disabled="patent.isComp" v-model="patent.receptionNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
                </tr>
              </table>
            </div>
            <div class="card-content margin-top" v-if="patent.isAnalysisOrder">
              <span style="font-size: 20px">解析依頼情報</span>
              <table>
                <tr>
                  <th style="vertical-align:top;">申送り事項</th><td><textarea :disabled="patent.isComp" v-model="patent.handoverInformation" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
                </tr>
              </table>
            </div>
            <div class="button-area">
              <b-button v-if="!patent.isShipped" type="is-primary" @click="cancel(index)">検査をキャンセル</b-button>
            </div>
          </div>
        </template>
        <b-modal :active.sync="officeCalenderActive" has-modal-card>
          <officeCalenderModal :miniday="miniday" :maxDay="maxday" :disabledDays="disabledDays" @select="setShippingDate" @change-page="changePage"></officeCalenderModal>
        </b-modal>
        <b-modal :active.sync="isChangeDeviceModalActive" has-modal-card>
          <changeDeviceModal v-bind:oldSerialNumber="oldSerial" v-bind:model="modelId" v-bind:choicesType="choicesType.hstKind" v-bind:receptionNo="serialCahngeReceptionNo" v-bind:type="'HST'" v-on:save="setNewSerial"></changeDeviceModal>
        </b-modal>
        <div class="button-area">
          <b-button type="is-primary" style="margin-left:12%;" @click="receptionist">更新</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  choicesType,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
import ChangeDeviceModal from "@/components/mock/philips/common/ChangeDeviceModal";
const estimateSnoreSensorCode = { 
  noEstimate: 0, 
  onlyWithoutSensor:1,
  onlyWithSensor: 2,
  both:3
};

export default {
  name: "HSTDetailEdit",
  methods: {
    back: function() {
      this.$router.push({
        name: "HSTRequestContentChange",
        params: { searchConditions: this.searchParams },
      });
    },
    inputBirthday: function(birthday,index){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.data[index].age = age < 0 ? 0 : age
      }else{
        this.data[index].age = ""
      }
    },
    receptionist: function() {
      // バリデーションチェック
      var elements = Array.from(document.getElementsByClassName("edit"));
      for (var i = 0; i < this.data.length; i++) {
        var subElements = document.getElementsByClassName("edit" + i);
        elements.push(...subElements);
      }

      var result = this.selfMadeValidation(elements);
      var isError = result.isError;
      var errorMsg = result.msg;

      if(isError){
        this.showErrorMessage(errorMsg)
        return
      }
      var isSw = this.isSW()
      for(const patient of this.data){
        if(!isSw) {
          patient.beltSize = ""
          patient.attachedWaveform = ""
          patient.cannulaSize = ""
        }
      }
      // this.updateTargetData = this.data[index]
      var excuteApi = this.setHstReceptionContentsUpdatePOST;
      var successCallBack = this.setHstReceptionContentsUpdatePOSTSuccess;
      var errorCallBack = this.setHstReceptionContentsUpdatePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstReceptionContentsUpdatePOST: function(client) {
      // var obj = JSON.parse(JSON.stringify(this.updateTargetData));
      var obj = JSON.parse(JSON.stringify(this.data))
      // obj.targetNumber = this.targetNumber
      var keys = Object.keys(this.commonItems)
      var isHospital = this.commonItems.delivaryTarget=="hospital"
      for(var i = 0; i < obj.length; i++){
        obj[i].patientId = obj[i].patientId ? obj[i].patientId.replace(/^\s+/, "") : obj[i].patientId
        obj[i].age = obj[i].age + ""
        obj[i].model = this.modelId
        for(var j = 0; j < keys.length; j++){
          if(!isHospital){
            if(keys[j] == "postcode" || keys[j] == "address" ||
            keys[j] == "houseNumber" || keys[j] == "building" ||
            keys[j] == "destination" || keys[j] == "phoneNumber" ||
            keys[j] == "desiredPickupTimeZone"){
              continue;
            }
          }
          obj[i][keys[j]] = this.commonItems[keys[j]]
        }
      }
      return client.apis.internalHst.setHstReceptionContentsUpdatePOST({
        body:obj
      });
    },
    setHstReceptionContentsUpdatePOSTSuccess: function(result) {
      // メッセージ表示
      this.updateTargetData = {}
      this.showSuccess(result);
    },
    setHstReceptionContentsUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.updateTargetData = {}
      this.showErrorMessage(result);
    },
    cancel: function(index) {
      this.updateTargetData = this.data[index]
      this.cancelReasonInputModalActive = true
    },
    reasonInput: function(reason) {
      this.cancelReason = reason
      var excuteApi = this.setHstReceptionInspectionCancelPOST;
      var successCallBack = this.setHstReceptionInspectionCancelPOSTSuccess;
      var errorCallBack = this.setHstReceptionInspectionCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstReceptionInspectionCancelPOST: function(client) {
      return client.apis.internalHst.setHstReceptionInspectionCancelPOST({
        body:{
          receptionNo:this.updateTargetData.receptionNo,
          reason:this.cancelReason,
          version:this.updateTargetData.version
        }
      });
    },
    setHstReceptionInspectionCancelPOSTSuccess: function(result) {
      // メッセージ表示
      if(this.data.length == 1){
        this.showSuccess(result,this.back());
        return
      }
      // this.data = this.data.filter(val => val.receptionNo != this.updateTargetData.receptionNo)
      this.updateTargetData = {}
      this.cancelReason = ""
      this.showSuccess(result);
      this.doSearch()
    },
    setHstReceptionInspectionCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.updateTargetData = {}
      this.showErrorMessage(result);
    },
    deletePatient: function(index) {
      this.data.splice(index, 1);
    },
    doSearch: async function() {
      var excuteApi = this.getHstReceptionContentsDetailPOST;
      var successCallBack = this.getHstReceptionContentsDetailPOSTSuccess;
      var errorCallBack = this.getHstReceptionContentsDetailPOSTError;
      // Web Api Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHstReceptionContentsDetailPOST: async function(client) {
      return client.apis.internalHst.getHstReceptionContentsDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHstReceptionContentsDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj;
      var deviceReservation = this.data.find(val => val.isDeviceReservation)
      var isDeviceReservation = deviceReservation ?  true : false
      var completed = this.data.find(val => !val.isComp)
      var isComp = completed ? false : true
      this.commonItems = {
        hospitalName:this.data[0].hospitalName,
        doctorName : this.data[0].doctorName,
        clerkName : this.data[0].clerkName,
        delivaryTarget : this.data[0].delivaryTarget,
        hospitalPostcode : this.data[0].hospitalPostcode,
        hospitalAddress : this.data[0].hospitalAddress,
        hospitalHouseNumber : this.data[0].hospitalHouseNumber,
        hospitalBuilding : this.data[0].hospitalBuilding,
        hospitalDestination : this.data[0].hospitalDestination,
        hospitalPhoneNumber : this.data[0].hospitalPhoneNumber,
        hospitalDesiredPickupTimeZone : this.data[0].hospitalDesiredPickupTimeZone,
        postcode : this.data[0].postcode,
        address : this.data[0].address,
        houseNumber : this.data[0].houseNumber,
        building : this.data[0].building,
        destination : this.data[0].destination,
        phoneNumber : this.data[0].phoneNumber,
        desiredPickupTimeZone : this.data[0].desiredPickupTimeZone,
        resultDeliveryPostcode : this.data[0].resultDeliveryPostcode,
        resultDeliveryAddress : this.data[0].resultDeliveryAddress,
        resultDeliveryBuilding : this.data[0].resultDeliveryBuilding,
        resultDeliveryHospital : this.data[0].resultDeliveryHospital,
        resultDeliveryDepartment : this.data[0].resultDeliveryDepartment,
        resultDeliveryDestination : this.data[0].resultDeliveryDestination,
        resultDeliveryPhoneNumber : this.data[0].resultDeliveryPhoneNumber,
        deliverySlip : this.data[0].deliverySlip,
        delivaryTarget : this.data[0].delivaryTarget,
        demo : this.data[0].demo,
        isDeviceReservation:isDeviceReservation,
        isComp:isComp,
        createInternal:this.data[0].createInternal,
        snoreSensor: this.data[0].snoreSensor
      }
      this.isLoad = true;
      this.modelId = this.data[0].model;
      this.registeredModel = this.data[0].model;
      this.registeredSnoreSensor = this.data[0].snoreSensor;
      this.belongsId = this.data[0].belongsId;
      this.institutionId = this.data[0].institutionId;
    },
    getHstReceptionContentsDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    getChoicesListLinkedEstimate: function() {
      var excuteApi = this.getChoicesListLinkedEstimatePOST;
      var successCallBack = this.getChoicesListLinkedEstimatePOSTSuccess;
      var errorCallBack = this.getChoicesListLinkedEstimatePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getChoicesListLinkedEstimatePOST: function(client){
      return client.apis.apiCommon.getChoicesListLinkedEstimatePOST({
        body: {
          belongId: this.belongsId,
          institutionId: this.institutionId
        }
      });
    },
    getChoicesListLinkedEstimatePOSTSuccess: function(result) {
      //機種リストをAPIからの取得値から抽出
      this.modelListLinkedEstimate = result.obj.filter(data => { 
        return data.choicesType == this.choicesType.hstKind
      });
      //見積りコードが登録されている機種が1件以上
      if(this.modelListLinkedEstimate.length > 0){
        let registeredModelList = this.modelListLinkedEstimate.filter(data => { return data.value == this.registeredModel });
        //案件に登録されている機種がない場合、案件に登録されている機種を選択可にする
        if(registeredModelList.length <= 0){
          //追加する行取得
          let registedModelRow = this.allModelList.find(data => { return data.value == this.registeredModel })
          //案件に設定されている行追加
          this.modelListLinkedEstimate.push(registedModelRow)
          //並び順でソート
          this.modelListLinkedEstimate.sort(function(first,second){
            if(first.displayOrder > second.displayOrder){
              return 1
            } else if(first.displayOrder < second.displayOrder){
              return -1
            } else {
              return 0
            }
          })
        }
      }
      //空行追加
      this.modelListLinkedEstimate.unshift({})
      
      //いびきセンサーの見積りの設定状態を取得
      if(this.modelListLinkedEstimate.length <= 1){
        //見積りコードが登録されている機種がない場合、見積りなしを設定
        this.estimateSnoreSensorState = estimateSnoreSensorCode.noEstimate
      } else {
        //WP300のいびきセンサーの見積りが紐づく項目をAPIからの取得値から抽出
        let estimateWP300Sensor =  result.obj.filter(data => { return data.choicesType == this.choicesType.WP300SnoreSensor });
        let estimateNoSensor = estimateWP300Sensor.filter(data => { return data.value == 1 });
        let estimateSensor = estimateWP300Sensor.filter(data => { return data.value == 2 });

        //いびきセンサーの見積り紐づき状態を設定
        if (estimateNoSensor.length <= 0 && estimateSensor.length <= 0){
          this.estimateSnoreSensorState = estimateSnoreSensorCode.noEstimate
        } else if (estimateNoSensor.length > 0 && estimateSensor.length <= 0) {
          this.estimateSnoreSensorState = estimateSnoreSensorCode.onlyWithoutSensor
        } else if (estimateNoSensor.length <= 0 && estimateSensor.length > 0) {
          this.estimateSnoreSensorState = estimateSnoreSensorCode.onlyWithSensor
        } else {
          this.estimateSnoreSensorState = estimateSnoreSensorCode.both
        }
      }
      this.setModelList(this.commonItems.demo)
    },
    getChoicesListLinkedEstimatePOSTError: function(result){
      this.showErrorMessage(result);
    },
    setModelList: function(isDemo){
      if(this.commonItems.isDeviceReservation || this.commonItems.isComp){
        return
      }
      if(isDemo){
        // 選択肢マスタの機種を設定
        this.modelList = this.getChoiceList(this.choicesType.hstKind, false);
        this.modelList.unshift({})
        // いびきセンサーのチェックボックスを活性
        this.disabledSnoreSensor = false
      } else {
        // 見積りコードが紐づいている機種を設定
        this.modelList = this.modelListLinkedEstimate
        // 見積りコードが登録されている機種がないとき、機種といびきセンサーを案件に設定されているものにリセット
        if(this.modelListLinkedEstimate.length <= 1){
          this.modelId = this.registeredModel
          this.commonItems.snoreSensor = this.registeredSnoreSensor
        } else {
          // 選択されている機種に見積りコードが登録されていないとき、機種といびきセンサーを案件に設定されているものにリセット
          let selectModel = this.modelListLinkedEstimate.filter(data => { return data.value == this.modelId });
          if(selectModel.length <= 0){
            this.modelId = this.registeredModel
            this.commonItems.snoreSensor = this.registeredSnoreSensor
          }
        }

        // いびきセンサーの有無の値と活性状態を更新
        switch(this.estimateSnoreSensorState){
          case estimateSnoreSensorCode.noEstimate:
            this.disabledSnoreSensor = true
            break
          case estimateSnoreSensorCode.onlyWithoutSensor:
            if(this.registeredSnoreSensor){
              this.disabledSnoreSensor = false
            } else {
              this.disabledSnoreSensor = true
              this.commonItems.snoreSensor = false
            }
            break
          case estimateSnoreSensorCode.onlyWithSensor:
            if(this.registeredSnoreSensor){
              this.disabledSnoreSensor = true
              this.commonItems.snoreSensor = true
            } else {
              this.disabledSnoreSensor = false
            }
            break
          case estimateSnoreSensorCode.both:
            this.disabledSnoreSensor = false
            break
        }
      }
    },
    addressSearch: function(target,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if(target!="result"){
          this.commonItems.hospitalAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.commonItems.hospitalHouseNumber = "";
          this.commonItems.hospitalBuilding = "";

          // QA476 住所設定後フォーカスを移動する
          this.focusMove("hospitalHouseNumber");
          this.digitErrorHospitalPostcode = false;
        }else{
          this.commonItems.resultDeliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.commonItems.resultDeliveryBuilding = "";

          // QA476 住所設定後フォーカスを移動する
          this.focusMove("resultAddress");
          this.digitErrorResultPostcode = false;
        }
      })
    },
    patientAddressSearch: async function(index,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      await this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        this.data[index].address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.data[index].houseNumber = "";
        this.data[index].building = "";

        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    isSW: function() {
      var model = this.modelList.find(val => val.value == this.modelId)
      if(model && model.label1 && model.label1.match(/スマートウォッチ/)){
        return true
      }
      return false
    },
    desiredShippingDateSelect: function(index){
      this.desiredShippingDateSelectIndex = index
      this.officeCalenderActive = true;
    },
    setShippingDate: function(selectDate){
      this.data[this.desiredShippingDateSelectIndex].desiredShippingDate = selectDate
      this.officeCalenderActive = false;
      this.desiredShippingDateSelectIndex = null
    },
    changePage: function(sDate, eDate) {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalShipmentCalendar.getStockCalendarPOST({
            body: {
              startDate: sDate,
              endDate: eDate,
              modelId: _this.modelId,
              receptionNo: _this.targetNumber[0]
            }
          });
        },
        function(result){
          var disabled = result.obj.filter(data => {
            return data.stock < _this.targetNumber.length
          })
          _this.disabledDays = disabled
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    changeCommonItems: function(value, targetName) {
      for(var i = 0; i < this.data.length; i++){
        this.data[i][targetName] = value
      }
    },
    changeSerial: function(index, serial, receptionNo) {
      this.serialCahngeIndex = index
      this.serialCahngeReceptionNo = receptionNo
      this.oldSerial = serial
      this.isChangeDeviceModalActive = true
    },
    setNewSerial: function(newSerial) {
      this.data[this.serialCahngeIndex].serial = newSerial
      this.oldSerial = ""
      this.serialCahngeIndex = null
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      if (flagName !== null && typeof flagName === "object" && !Array.isArray(flagName)) {
        if (!('digitErrorPatientPostcode' in flagName)) {
          this.$set(flagName, 'digitErrorPatientPostcode', false);
        }
        flagName.digitErrorPatientPostcode = zipCode.length < 7;
      }else {
        this[flagName] = zipCode.length < 7;
      }
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    },
    setupZipWatchers() {
      this.data.forEach((item, index) => {
        this.$watch(() => item.postcode,
          async (newZip, oldZip) => {
            if (newZip === oldZip) return;
            // 何も入ってないまたは7桁未満なら何もしない
            if (!newZip || newZip.length !== 7) return;
            if (isNaN(Number(newZip))) return;

            // 住所検索
            await this.patientAddressSearch(index, newZip);

            // 検索後に住所欄へフォーカス
            this.$nextTick(() => {
              var houseNumber = document.getElementById(`houseNumber_${index}`);
              houseNumber.focus();
            });
          }
        );
      });
    }
  },
  data() {
    var targetNumber = decodeURIComponent(this.$route.query["receiptNumber"])
    var receiptNumberList = decodeURIComponent(this.$route.query["receiptNumber"])
    if (!Array.isArray(targetNumber)) {
      targetNumber = targetNumber.split(",")
    }
    var receiptNumber = targetNumber[0];
    var searchParams = this.$route.params["searchConditions"];
    var cannulaSizeList = this.getChoiceList(choicesType.cannulaSize, false);
    var beltSizeList = this.getChoiceList(choicesType.beltSize, false);
    var attachedWaveformList =  this.getChoiceList(choicesType.attachedWaveform, false);
    var modelList = this.getChoiceList(choicesType.hstKind, false);
    var allModelList = this.getChoiceList(choicesType.hstKind, false);
    var desiredDeliveryTimeZoneList = this.getChoiceList(choicesType.deliveryTime, false);
    desiredDeliveryTimeZoneList.unshift({})
    var miniday = new Date(new Date().setHours(0, 0, 0, 0));
    var maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    var maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    return {
      isLoad: false,
      data: [
        {digitErrorPatientPostcode:false}
      ],
      commonItems:[],
      targetNumber,
      receiptNumber,
      searchParams,
      cannulaSizeList,
      beltSizeList,
      attachedWaveformList,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      updateTargetData:{},
      cancelReasonInputModalActive:false,
      cancelReason:"",
      miniday,
      maxday,
      officeCalenderActive: false,
      disabledDays:[],
      modelId: null,
      modelList,
      modelListLinkedEstimate:[],
      allModelList,
      registeredModel: "",
      registeredSnoreSensor: "",
      desiredDeliveryTimeZoneList,
      receiptNumberList,
      serialCahngeIndex:null,
      serialCahngeReceptionNo:"",
      oldSerial:"",
      isChangeDeviceModalActive:false,
      choicesType,
      invalidShippingPostcode: false,
      invalidShippingPhoneNumber: false,
      invalidDeliveryPostcode: false,
      invalidDeliveryPhoneNumber: false,
      belongsId: 0,
      institutionId: 0,
      disabledSnoreSensor: true,
      estimateSnoreSensorState: 0,
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      digitErrorZipMessage,
      digitErrorHospitalPostcode:false,
      digitErrorResultPostcode:false,
      isInitialZip:true,
      isInitialResultZip:true,
    };
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
    // 見積りコードが紐づいている機器取得
    if(!this.commonItems.isDeviceReservation&&!this.commonItems.isComp){
      await this.getChoicesListLinkedEstimate();
    }
    this.setupZipWatchers();
  },
  filters: {
    formatDate: function(val){
      if(!val) return ""
      return val.replace(/-/g, "/")
    },
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    reasonInputModal:reasonInputModal,
    officeCalenderModal:OfficeCalenderModal,
    changeDeviceModal:ChangeDeviceModal
  },
  watch: {
    "commonItems.hospitalPostcode"(newValue) {
      this.invalidShippingPostCode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitialZip) {
        this.isInitialZip = false;
        return
      }
      if (!this.invalidDeviceDestinationPostcode && newValue.length === 7) {
        this.addressSearch('device', newValue);
      }
    },
    "commonItems.hospitalPhoneNumber"(newValue) {
      this.invalidShippingPhoneNumber = isNaN(Number(newValue));
    },
    "commonItems.resultDeliveryPostcode"(newValue) {
      this.invalidDeliveryPostCode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitialResultZip) {
        this.isInitialResultZip = false;
        return
      }
      if (!this.invalidResultDestinationPostcode && newValue.length === 7) {
        this.addressSearch('result', newValue);
      }
    },
    "commonItems.resultDeliveryPhoneNumber"(newValue) {
      this.invalidDeliveryPhoneNumber = isNaN(Number(newValue));
    },
    "data": {
      handler(newValue) {
        newValue.map((value) => {
          value.invalidPatientPostCode = isNaN(Number(value.postcode));
          value.invalidPatientPhoneNumber = isNaN(Number(value.phoneNumber));
        });
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTDetailEdit.vue